import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";


import StoresMapMiddlewareProxy from "./StoresMapMiddlewareProxy";

export const setStoresMapMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.STORES_MAP.GET_ALL_STORES:
    StoresMapMiddlewareProxy.getAllStores(next, action.payload.params);
    break;
  case ActionTypes.STORES_MAP.GET_ONLY_STORES:
    StoresMapMiddlewareProxy.getOnlyStores(next, action.payload.params);
    break;
  case ActionTypes.STORES_MAP.GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY:
    StoresMapMiddlewareProxy.getMultipleProductStoreAvailability(store.getState(), next, action.payload.params);
    break;
  case ActionTypes.STORES_MAP.GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_COMPLEX:
    StoresMapMiddlewareProxy.getMultipleProductStoreAvailabilityComplex(store.getState(), next);
    break;
  case `${MiddlewareEntities.STORES_MAP} ${ActionTypes.API_SUCCESS}` :
    StoresMapMiddlewareProxy.getStoresAPISuccess(next, action.payload);
    break;
  case `${MiddlewareEntities.STORES_MAP} ${ActionTypes.API_ERROR}` :
    StoresMapMiddlewareProxy.getStoresAPIError(next, action.payload);
    break;
  case ActionTypes.STORES_MAP.GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_AND_SET_ACTIVE_ID:
    StoresMapMiddlewareProxy.getStoresAvailabilityAndSetActiveIdAction(store, next, action.payload.params);
    break;
  case `${MiddlewareEntities.STORES_MAP_MULTIPLE} ${ActionTypes.API_SUCCESS}` :
    StoresMapMiddlewareProxy.getMultipleStoresApiSuccess(store, next, action.payload);
    break;
  case `${MiddlewareEntities.STORES_MAP_MULTIPLE} ${ActionTypes.API_ERROR}` :
    StoresMapMiddlewareProxy.getStoresAPIError(next, action.payload);
    break;
  case ActionTypes.STORES_MAP.CLOSE:
    StoresMapMiddlewareProxy.close(next);
    break;
  default:
    break;
  }
};

export const getClosestStoresMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.STORES_MAP.SET_CLOSEST_STORES_STATUS:
    StoresMapMiddlewareProxy.setClosestStoresStatus(store, action.payload, next);
    break;
  case ActionTypes.STORES_MAP.GET_CLOSEST_STORES:
    StoresMapMiddlewareProxy.getClosestStores(store.getState(), next);
    break;
  case `${MiddlewareEntities.STORES_MAP_CLOSEST} ${ActionTypes.API_SUCCESS}`:
    StoresMapMiddlewareProxy.getClosestStoresAPISuccess(next, action.payload);
    break;
  default:
    break;
  }
};

export const getUserGeoLocationMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.STORES_MAP.GET_USER_GEO_LOCATION:
    StoresMapMiddlewareProxy.getUserGeoLocation(next);
    break;
  default:
    break;
  }
};

export const setCitiesMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.STORES_MAP.GET_CITIES:
    StoresMapMiddlewareProxy.getCities(next, action.payload);
    break;
  default:
    break;
  }
};

export const setActiveStoreMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.STORES_MAP.SET_ACTIVE_STORE_ID:
    StoresMapMiddlewareProxy.setActiveStoreId(store.getState(), next, action.payload);
    break;
  default:
    break;
  }
};

export const storesMapMiddleware = [
  setStoresMapMiddleware,
  getUserGeoLocationMiddleware,
  setCitiesMiddleware,
  setActiveStoreMiddleware,
  getClosestStoresMiddleware
];
